import React, { JSX, useMemo } from 'react';
import { Spinner, Box, Heading } from '@chakra-ui/react';
import StandardTranslationWithMarkup from 'components/common/atoms/StandardTranslationWithMarkup';

import { PrivacyPolicyProps } from './PrivacyPolicy.types';

function PrivacyPolicy({ t, tReady }: PrivacyPolicyProps): JSX.Element {

    const sections = useMemo(
        () => {
            return tReady
                ? t('privacyPolicy:sections', { returnObjects: true }) as []
                : undefined;
        },
        [t, tReady],
    );

    return (
        <Box>
            {sections && sections?.length > 0 ? (
                <>
                    <div>
                        <Heading size="2xl" textAlign="center">{t('privacyPolicy:screenTitle.heading1')}</Heading>
                        <Heading size="xl" textAlign="center">{t('privacyPolicy:screenTitle.heading2')}</Heading>
                    </div>

                    {sections.map((section, index) => (
                        <Box key={index} pb={'20px'}>
                            <Heading pb={'10px'}>{t(`privacyPolicy:sections.${index}.heading`)}</Heading>
                            <StandardTranslationWithMarkup
                                translationKey={`sections.${index}.content`}
                                namespace="privacyPolicy"
                                values={{}}
                                t={t}
                            />
                        </Box>
                    ))}
                </>
            ) : <Spinner />}
        </Box>
    );
}


export default PrivacyPolicy;
